// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { createAsyncThunk } from '@reduxjs/toolkit';

import axiosInstance from '../../services/axiosInstance';
import { apiCall } from '../utils/utils';

// get Scenes
export const fetchScenes = createAsyncThunk(
  'scenes/fetchScenesAll',
  async (_, { rejectWithValue }) =>
    await apiCall(() => axiosInstance.get(`scene/all/`), rejectWithValue)
);

// get company scenes
export const fetchCompanyScenes = createAsyncThunk(
  'scenes/fetchCompanyScenes',
  async (companyUuid, { rejectWithValue }) =>
    await apiCall(() => axiosInstance.get(`scene/all/${companyUuid}/`), rejectWithValue)
);

// get scene by uuid
export const fetchSceneById = createAsyncThunk(
  'scenes/fetchSceneById',
  async (sceneId, { getState, rejectWithValue }) => {
    const state = getState();
    const scene = state.scenes.scenes.find(el => el.scene_uuid === sceneId);
    if (!scene) {
      return await apiCall(() => axiosInstance.get(`scene/${sceneId}/`), rejectWithValue);
    }
    return scene;
  }
);

// add keyword to scene
export const addKeywordToScene = createAsyncThunk(
  'keyword/addToScene',
  async (data, { rejectWithValue }) =>
    apiCall(() => axiosInstance.post(`scene/add/keyword/`, data), rejectWithValue)
);

// delete keyword from scene
export const deleteKeywordFromScene = createAsyncThunk(
  'keyword/deleteKeywordFromScene ',
  async ({ sceneId, keywordId }, { rejectWithValue }) => {
    try {
      await apiCall(
        () => axiosInstance.delete(`scene/delete/scenekeyword/${sceneId}/${keywordId}`),
        rejectWithValue
      );
      return { sceneId, keywordId };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// add unreal version to scene //TODO

// delete unreal version from scene //TODO

// buy scene //TODO

// filtered scenes
export const filteredScenes = createAsyncThunk(
  'scenes/filtered',
  async (data, { rejectWithValue }) =>
    apiCall(() => axiosInstance.post(`scene/filtered/`, data), rejectWithValue)
);

// filter scenes by provider/scen_dimension/status
export const localFilterScenes = createAsyncThunk(
  'scenes/localFilterScenes',
  async ({ filterType, filterValue, sortOrder = 'desc' }, { getState, rejectWithValue }) => {
    const { scenes, studio, companies } = getState();
    const { provider = [] } = companies.company;
    const sorting = scenes?.filterScenes?.sortOrder;

    let filtered = [];
    let providerList = [];

    if (filterType === 'status') {
      filtered = studio.studio.studio_scenes
        ?.filter(item => item.status === filterValue)
        ?.map(item => item.scene)
        ?.filter(Boolean);
    } else if (filterType === 'provider') {
      filtered = scenes.scenes?.filter(scene => scene?.provider?.name === filterValue);
      providerList = provider?.filter(p => p.name === filterValue);
    } else if (filterType === 'type') {
      filtered = scenes.scenes?.filter(scene => scene?.provider?.scene_type === filterValue);
      providerList = provider?.filter(p => p.scene_type === filterValue);
    } else if (filterType === 'last_updated') {
      filtered = [...scenes.scenes].sort((a, b) => {
        const aTime = new Date(a.last_updated).getTime();
        const bTime = new Date(b.last_updated).getTime();
        return sortOrder === 'asc' ? aTime - bTime : bTime - aTime;
      });
    } else {
      throw new Error('Invalid filter type');
    }

    if (filterType !== 'last_updated' && sorting) {
      filtered = [...filtered].sort((a, b) => {
        const aTime = new Date(a.last_updated).getTime();
        const bTime = new Date(b.last_updated).getTime();
        return sorting === 'asc' ? aTime - bTime : bTime - aTime;
      });
    }

    if (!filtered || filtered.length === 0) {
      return rejectWithValue('We found no results that closely match your search.');
    }

    return {
      scenes: filtered,
      providers: providerList,
      sortOrder,
      ...(filterType !== 'last_updated' && { filterValue }),
    };
  }
);

// update scene
export const updateScene = createAsyncThunk('scene/update', async (data, { rejectWithValue }) =>
  apiCall(() => axiosInstance.patch(`scene/update/`, data), rejectWithValue)
);

// delete scene
export const deleteScene = createAsyncThunk('scene/delete', async (sceneId, { rejectWithValue }) =>
  apiCall(() => axiosInstance.delete(`scene/delete/${sceneId}/`), rejectWithValue)
);

// get unreal versions
export const fetchUnrealVersion = createAsyncThunk(
  'unreal/fetchUnrealVersionAll',
  async (_, { rejectWithValue }) => apiCall(() => axiosInstance.get(`unreal/all/`), rejectWithValue)
);

// add unreal version //TODO
// delete unreal version //TODO
